import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import MessageContactService from "@/integrations/service/message-contact.service";

const QUERY_KEY = ["messages-contact"];

export const useCreerMessageContact = () => {
  return useMutation({
    mutationFn: MessageContactService.creer,
  });
};

export const useMessagesContact = () => {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: MessageContactService.getAll,
  });
};

export const useMarquerLuMessageContact = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: MessageContactService.marquerLu,
    onSuccess: () => qc.invalidateQueries({ queryKey: QUERY_KEY }),
  });
};

export const useDeleteMessageContact = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: MessageContactService.delete,
    onSuccess: () => qc.invalidateQueries({ queryKey: QUERY_KEY }),
  });
};
